module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Archer_S10.55ce610.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Archer_S10.jpg
// module id = 072l
// module chunks = 0